import "./About.css";
import shihab from "../../assests/images/shihab.jpg";
import Copyright from "../../reuseable/Copyright/Copyright";
import { BsFillCameraFill } from "react-icons/bs";
import shihabphoto from "../../assests/images/shihabphoto.jpg";
import { FaUserGraduate } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

function About() {
  return (
    <div className="about-me-container container ">
      <div className="about-me-wrapper">
        <div className="about-me-profile-container">
          <div className="about-me-profile">
            <div className="about-me-profile-image">
              <img src={shihab} alt="shihab" className="about-me-mini-image" />
              <BsFillCameraFill className="about-me-picture-camera" size={35} />
            </div>
            <div className="about-me-title-section">
              <h2>Shihab Ahmed</h2>
              <b>Software Artisan</b>
            </div>
          </div>
          {/* <Details /> */}

          <div className="about-me-details-container">
            <div className="about-me-details">
              <div className="about-me-study-details">
                <p className="about-me-study">
                  <FaUserGraduate size={20} className="about-me-study-icon" />{" "}
                  B.Sc in Computer science and Engineering (CSE)
                  <br />
                  at Daffodil International University
                </p>
                <p className="about-me-study">
                  <FaHome />
                  Lives in <b>Antalya, Turkey</b>
                </p>
                <a
                  href="https://github.com/shihab-sa"
                  target="_blank"
                  className="about-me-study"
                  rel="noopener noreferrer"
                >
                  <FaGithub />
                  shihab-sa
                </a>
                <a
                  href="https://www.linkedin.com/in/shihab-ahmed-57b161152/"
                  target="_blank"
                  className="about-me-study"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin /> shihabah
                </a>
              </div>
            </div>
          </div>

          {/* <AboutMeDetails /> */}

          <div className="about-me-my-personal-info">
            <h1>It's me Shihab</h1>
            <p className="about-me-details-describtion">
              I'm <b>Shihab Ahmed Software Engineer from Bangladesh.</b> I do
              Works on remotely / <b>Project based /Freelancing</b> . I'm Good
              At problem solving skills. Understanding language philosophy such
              as JavaScript , TypeScript, and can be solve any type of problems
              using
              <b> Data Structure and Algorithm.</b>
            </p>
            <div className="about-me-details-describtion">
              <img src={shihabphoto} alt="" className="about-me-photo" />
            </div>
            <h1 className="more-about-me">More About Me</h1>
            <p className="about-me-details-describtion">
              In future I want to become a better <b>back end engineer</b>,
              that's why i'm learning a lot of new things. I know row node Js ,
              Express Js, MySql , mongo db and so on.Currently my expertise and
              showing creative works only for that Front End Part, MERN , React
              Native.
              <br />
            </p>
          </div>
        </div>
        <Copyright />
      </div>
    </div>
  );
}

export default About;
